import { httpCreate } from './http';

const http = httpCreate('/shop/api/reseller');

export const reseller = {
	list(params) {
		return http.post(`/list?pageSize=${params.pageSize}&pageNum=${params.pageNum}`, params);
	},
	checkList(params) {
		return http.post(`/check/list?pageSize=${params.pageSize}&pageNum=${params.pageNum}`, params);
	},
	deleteReseller(ids, activityId) {
		let url = '';

		if (activityId) {
			url = `?activityId=${activityId}`;
		}
		return http.delete(url, {
			data: ids,
		});
	},
	batchCheckDelete(params) {
		return http.delete('/batchCheckDelete', { data: params });
	},
	batchCheck(status, params) {
		return http.put(`/batchCheck/${status}`, params);
	},
	//直播间推广员列表
	productList(id, params) {
		return http.get(`/productList/${id}`, { params });
	},
	//禁用
	Disabled(id, status) {
		return http.put(`/${id}/forbid/${status}`);
	},
	// 获取所有未审核申请id
	unRevisedIds() {
		return http.get('/withdrawal/unrevisedIds');
	},
	// 获取提现审核列表
	applications(params) {
		return http.get('/withdrawal/applications', { params });
	},
	// 提现审核
	operate(applicationId, status, payload) {
		/* 
            applicationId : 审核id
            status : 1:通过 -1：驳回
        */
		return http.post(`/withdrawal/operate/${applicationId}/${status}`, payload);
	},
	withdrawalAgree(applicationId, type) {
		return http.post(`/withdrawal/agree/${applicationId}/${type}`);
	},
	withdrawalRefuse(applicationId, data) {
		return http.post(`/withdrawal/refuse/${applicationId}`, data);
	},
	getWithdrawalInfo() {
		return http.get('/withdrawal/info');
	},
	getResellerInfo({ companyUserId, resellerId, activityId }) {
		return http.get(`/${companyUserId}/statistics/${resellerId}`, { params: { activityId } });
	},
	getLowerList(resellerId, params) {
		return http.get(`/list/lower/${resellerId}`, { params });
	},
	update(id, data) {
		return http.put(`/update/${id}`, data);
	},
	activityInfo(id) {
		return http.get(`/activityInfo/${id}`);
	},
	addList(id, params) {
		return http.post(`/${id}/addList?pageSize=${params.pageSize}&pageNum=${params.pageNum}`, params);
	},
	addPromoter(id, params) {
		return http.post(`/${id}/add`, params);
	},
};
